import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

function secondsToTime(secs) {
    const h = Math.floor(secs / (60 * 60));
    const divisorForMinutes = secs % (60 * 60);
    const m = Math.floor(divisorForMinutes / 60);
    const divisorForSeconds = divisorForMinutes % 60;
    const s = Math.ceil(divisorForSeconds);
    return { h, m, s };
}

function formatTime({ m, s }) {
    const minSec = m > 0 ? 'minutes' : 'seconds';
    return `${m}:${s < 10 ? `0${s}` : s} ${minSec}`;
}

const Countdown = ({ time }) => {
    const [seconds, setSeconds] = useState(time);

    useEffect(() => {
        if (seconds > 0) {
            const id = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(id);
        }
    }, [seconds]);

    return (
        <>
            <div>{formatTime(secondsToTime(seconds))}</div>
        </>
    );
};

Countdown.propTypes = {
    time: propTypes.number.isRequired
};

export default Countdown;
